import { createSelector } from 'reselect';
import { getDynamicLabelValues } from '../../../../../../../utils/labels/labelUtilty';

const getState = (state) => state;

export const getAddPickUpErrorState = createSelector(
  getState,
  (state) => state.AddPickUpPerson && state.AddPickUpPerson.pickUpErrorMessage
);

export const getErrorMessage = createSelector(getAddPickUpErrorState, (errorState) => {
  const { errorMessage } = errorState || {};
  const { errorCode, errorMessage: errMsg } = errorMessage || {};
  const addPickUpLabels = getDynamicLabelValues('dynamic.account_d');
  const labelKey = `lbl_addpickup_error_${errorCode}`;
  return (errorState && addPickUpLabels[labelKey]) || errMsg || labelKey;
});

export const getLoaderState = createSelector(
  getState,
  (state) => state.AddPickUpPerson && state.AddPickUpPerson.loader
);

export const getResetOrderPageinationState = createSelector(
  getState,
  (state) => state.AddPickUpPerson && state.AddPickUpPerson.resetOrderPaginationState
);

export const isShowSuccessMessage = createSelector(
  getState,
  (state) => state.AddPickUpPerson && state.AddPickUpPerson.showSuccessMsg
);

export const getModalData = createSelector(
  getState,
  (state) => state.AddPickUpPerson && state.AddPickUpPerson.modalData
);

export const getShowErrorMessage = createSelector(
  getState,
  (state) => state.AddPickUpPerson && state.AddPickUpPerson.showErrorMsg
);

export const getFormState = createSelector(
  getState,
  (state) => state.AddPickUpPerson && state.AddPickUpPerson.formState
);
